import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import BookingCTA from './components/BookingCTA';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://equi-as.no';

const beautySchema = {
  '@context': 'https://schema.org',
  '@type': 'BeautySalon',
  name: 'Equi AS',
  alternateName: 'Equi Velvære',
  url: SITE_URL,
  logo: `${SITE_URL}/img/equiIcon.png`,
  image: `${SITE_URL}/img/LogoTransparent.png`,
  description:
    'Equi AS er en premium skjønnhetsklinikk i Moelv (Rudshøgda) som tilbyr bryn og vipper, ansiktsbehandlinger, Plasma Pen, PRP, manikyr, fotpleie, voksing, LPG massasje, osteopati og frisørtjenester.',
  telephone: '+4746884700',
  email: 'minequi@hotmail.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Bogstivegen 72',
    addressLocality: 'Rudshøgda',
    postalCode: '2360',
    addressCountry: 'NO',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 60.9333,
    longitude: 10.6833,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '20:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '10:00',
      closes: '16:00',
    },
  ],
  sameAs: [
    'https://www.facebook.com/EQUInorway',
    'https://www.instagram.com/equivelvaeret/',
  ],
  priceRange: '$$',
  currenciesAccepted: 'NOK',
  paymentAccepted: 'Cash, Credit Card',
  areaServed: {
    '@type': 'City',
    name: 'Moelv',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Hvor er Equi AS skjønnhetsklinikk lokalisert?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Equi AS holder til på Bogstivegen 72, 2360 Rudshøgda, nær Moelv i Innlandet.',
      },
    },
    {
      '@type': 'Question',
      name: 'Hvilke behandlinger tilbyr Equi AS?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vi tilbyr bryn og vipper, ansiktsbehandlinger, Plasma Pen, PRP, manikyr, fotpleie, voksing, LPG massasje, osteopati og frisørtjenester.',
      },
    },
    {
      '@type': 'Question',
      name: 'Hvordan bestiller jeg time hos Equi AS?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Du kan bestille time online via vår bookingside på system.easypractice.net/book/equi, eller ringe oss på +47 468 84 700.',
      },
    },
  ],
};

function injectJsonLd(id: string, data: object): HTMLScriptElement {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
  return script;
}

export default function HomePage() {
  useEffect(() => {
    const s1 = injectJsonLd('ld-beauty-salon', beautySchema);
    const s2 = injectJsonLd('ld-faq-page', faqSchema);
    return () => {
      s1.remove();
      s2.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0e0a07]">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <BookingCTA />
      <Footer />
    </div>
  );
}
